import color from "./colors/colors.module.scss";
import typography from "@erelego/design-system/theme/defaultTheme/typography/typography.module.scss";
import spacing from "@erelego/design-system/theme/defaultTheme/spacing/spacing.module.scss";
import variables from "./variables/variables.module.scss";
import breakpoints from "@erelego/design-system/theme/breakpoints/breakpoints.module.scss";
import { ThemeType } from "@erelego/design-system/theme/themeProvider";
const theme: ThemeType = {
  color,
  typography,
  spacing,
  variables,
  breakpoints,
};

export default theme;
